export const CREDIT_INFO_RESET = 'CREDIT_INFO_RESET';
export const GRADE_TREND_UP = 'up';
export const GRADE_TREND_DOWN = 'down';
